import {Box, styled} from '@mui/material';

const StyledBox = styled(Box)`
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-inline: -16px;

		& .slide {
			flex-basis: 90%;
		}

		& .slide:first-of-type {
			flex-basis: 95%;
			padding-left: 16px;
		}

		& .slide:last-of-type {
			flex-basis: 95%;
			padding-right: 16px;
		}
	}
`;
export {StyledBox};
